<!--Only Visible AppgenPreview-->
<div class="main" unsavedChangesAlert>
  <div class="container-fluid mt-4" *ngIf="this.getDataFromRouting">
    <div class="row">
      <div class="col-md-4">
        <p class="dg-txt-primary dg-h-22">Form Preview</p>
      </div>
      <div class="col-md-8 text-end dg-btn">
        <button
          mat-stroked-button
          color="warn"
          class="px-3"
          (click)="onClose()"
        >
          Close & Edit Form
        </button>
      </div>
    </div>
  </div>
  <!--Appgen Container Start-->
  <div
    class="container-fluid pt-3 dg-ag-main-container"
    [ngClass]="this.getDataFromRouting ? 'dg-bg-white' : ''"
    id="appGenForm{{ this.FORMID }}"
  >
    <ng-container *ngFor="let data of res">
      <ng-container [ngSwitch]="true">
        <app-app-gen-expansionpanel
          *ngSwitchCase="data.fieldType == 93"
          [expansionData]="data.children"
          [attribute]="data.attribute"
          [eventId]="eventId"
        ></app-app-gen-expansionpanel>
        <app-app-gen-stepper
          *ngSwitchCase="data.fieldType == 97"
          [stepData]="data.children"
          [attribute]="data.attribute"
          [eventId]="eventId"
        ></app-app-gen-stepper>
        <app-app-gen-card
          *ngSwitchCase="data.fieldType == 89"
          [cardData]="data"
          [eventId]="eventId"
        >
        </app-app-gen-card>
        <app-gen-checklist
          *ngSwitchCase="data.fieldType == 107"
          [eventId]="eventId"
          [checklistData]="data"
          [attribute]="data.attribute"
          (appGenDataEmit)="appGenDataEmitFromCheckList($event)"
        ></app-gen-checklist>
        <app-app-gen-tab
          *ngSwitchCase="data.fieldType == 102"
          [tabData]="data.children"
          [tabObject]="data"
          [attribute]="data.attribute"
          [eventId]="eventId"
          (appGenDataEmit)="appGenDataEmitFromTab()"
        ></app-app-gen-tab>
        <app-gen-column
          *ngSwitchCase="data.fieldType == 106"
          [columnData]="data.children"
          [attribute]="data.attribute"
          [eventId]="eventId"
        ></app-gen-column>

        <app-common
          *ngSwitchCase="
            data.fieldType == 51 ||
            data.fieldType == 12 ||
            data.fieldType == 23 ||
            data.fieldType == 25 ||
            data.fieldType == 24 ||
            data.fieldType == 40 ||
            data.fieldType == 71 ||
            data.fieldType == 74 ||
            data.fieldType == 79 ||
            data.fieldType == 81 ||
            data.fieldType == 83 ||
            data.fieldType == 87 ||
            data.fieldType == 90 ||
            data.fieldType == 91 ||
            data.fieldType == 92 ||
            data.fieldType == 99 ||
            data.fieldType == 100 ||
            data.fieldType == 103 ||
            data.fieldType == 104 ||
            data.fieldType == 105 ||
            data.fieldType == 108 ||
            data.fieldType == 111 ||
            data.fieldType == 16
          "
          [res]="data"
          [formId]="FORMID"
          [tid]="tid"
          (emitTransId)="getTransId($event)"
          [ngClass]="data.fieldType == 99 ? 'AppGen-button' : ''"
          (appGenDataEmit)="appGenDataEmitFromDevForm($event)"
          (customCompData)="appGenDataEmitFromDevForm($event)"
        ></app-common>

        <ng-container *ngIf="eventId == 23">
          <ng-container *ngSwitchDefault>
            <div
              [ngClass]="
                data.attribute.className
                  ? data.attribute.className
                  : 'appgen-w-35'
              "
              class="dg-appgen-dynamic-input"
            >
              <dg-dynamic-input
                *ngIf="!data.attribute.hideShow"
                [id]="'comp' + data.attribute.fieldId"
                [data]="data.attribute"
                [value]="data?.defaultValue"
                [showLabel]="showLabel"
                [dataPropConfig]="inputDataPropConfig"
                [comboPropConfig]="comboPropConfig"
                [form]="commonService.appGenFormGroup"
                (onChangeEvent)="onInputChange(data, 'onChange')"
                (onBlurEvent)="onInputChange(data, 'onBlur')"
                (onSearchClick)="onInputChange(data, 'search')"
                (keypress)="onKeyPress($event)"
              >
              </dg-dynamic-input>
            </div>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="eventId != 23">
          <ng-container *ngSwitchDefault>
            <dg-dynamic-input
              *ngIf="!data.attribute.hideShow"
              [id]="'comp' + data.attribute.fieldId"
              [data]="data.attribute"
              [value]="data?.attribute.defaultValue"
              [showLabel]="showLabel"
              [dataPropConfig]="inputDataPropConfig"
              [comboPropConfig]="comboPropConfig"
              [form]="commonService.appGenFormGroup"
              [ngClass]="
                data.attribute.className
                  ? data.attribute.className
                  : 'appgen-w-35'
              "
              class="dg-appgen-dynamic-input"
              (onChangeEvent)="onInputChange(data, 'onChange')"
              (onBlurEvent)="onInputChange(data, 'onBlur')"
              (onSearchClick)="onInputChange(data, 'search')"
              (keypress)="onKeyPress($event)"
            >
            </dg-dynamic-input>
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-container>

    <ng-template
      #customComponent
      [componentLoader]=""
      [componentInputs]=""
      [componentOutputs]="['output', 'ruleCondition', 'refreshGrid']"
    >
    </ng-template>
  </div>
</div>
<!-- AppgenContainer End -->
